import { useState, useEffect } from 'react';
import { Col, Form, Radio, Space, Select, Typography, DatePicker, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';
import { useSelector } from 'react-redux';
import DownOutlinedMobile from '../../../../assets/icons/DownOutlinedMobile.svg';
import axios from 'axios';
import env from '../../../../environment';
import { InputNumber, ProvinceSelector } from 'afrodita';
import { useNavigate, useParams } from 'react-router-dom';

const { Option } = Select;
const { Text } = Typography;

const CurrentMortgageForm2 = ({ edit, dataOperation, form }) => {
	const { t } = useTranslation();
	const [nameBanks, setNameBanks] = useState(null);
	const userToken = useSelector((state) => state.auth.token);
	const params = useParams();

	const [valueRadio, setValueRadio] = useState(
		dataOperation?.subrogation?.whenSignedMortgage !== undefined
			? dataOperation.subrogation.whenSignedMortgage
			: undefined
	);
	const [valueEditMortgage, setValueEditMortgage] = useState(
		dataOperation?.subrogation?.whenSignedMortgage !== undefined
			? dataOperation.subrogation.whenSignedMortgage
			: undefined
	);
	const colSpan = {
		xxl: edit === undefined ? 24 : 6,
		xl: edit === undefined ? 24 : 6,
		lg: edit === undefined ? 24 : 8,
		md: edit === undefined ? 24 : 12,
		sm: 24,
		xs: 24
	};
	const [modalAndalucia, setModalAndalucia] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		axios
			.get(`${env.api.url}/v1/banks/get-banks`, {
				headers: {
					Authorization: `Bearer ${userToken}`
				}
			})
			.then((response) => {
				const filteredBanks = response.data.data.filter(
					(data) => !data.name.toLowerCase().includes('sabadell')
				);

				setNameBanks(filteredBanks);
			});
	}, []);

	const backTop = () => {
		setModalAndalucia(false);
		form.setFieldsValue({ province: 'Madrid' });
	};

	const onChangeProvince = (event) => {
		if (
			event === 'Almería' ||
			event === 'Granada' ||
			event === 'Málaga' ||
			event === 'Jaén' ||
			event === 'Córdoba' ||
			event === 'Sevilla' ||
			event === 'Cádiz' ||
			event === 'Huelva'
		) {
			setModalAndalucia(true);
		}
	};
	const closeOperation = () => {
		axios
			.post(
				`${env.api.url}/v1/operations/operation-close`,
				{
					operationId: params.operationId,
					applicant: 'Gibobs',
					closeReason: 'B. Sabadell - Compra en Andalucía',
					subCloseReason: 'B. Sabadell - Compra en Andalucía',
					body: 'B. Sabadell - Compra en Andalucía',
					closeAllTask: true
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then(() => {
				setModalAndalucia(false);
				navigate('/welcomeSelection');
				window.open('https://newsletters.bancsabadell.com/hipotecas', '_blank');
			});
	};

	return (
		<>
			<Col {...colSpan}>
				<Form.Item
					label={
						edit !== undefined
							? t('onboarding.bankWhereYouHaveYourMortgage')
							: t('onboarding.bankEntitiesQuestion')
					}
					rules={[
						{
							required: true
						}
					]}
					name="mortgageCurrentBank">
					<Select
						style={{ width: '100%' }}
						showSearch
						filterOption={(input, option) =>
							option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
						}
						suffixIcon={<img src={DownOutlinedMobile} alt="DownOutlinedMobile" />}
						placeholder={t('form.select')}>
						{nameBanks
							? nameBanks.map((nameBanks) => {
								return (
									<Option key={nameBanks.id} value={nameBanks.id}>
										{nameBanks.name}
									</Option>
								);
							})
							: null}
					</Select>
				</Form.Item>
			</Col>

			<Col {...colSpan}>
				<Form.Item
					name="maxBudget"
					label={edit !== undefined ? t('loan.homeCost') : t('loan.homeCost')}
					rules={[
						{
							required: true
						}
					]}>
					<InputNumber
						id="maxBudget"
						gbType="currency"
						max={99000000}
						maxLength="15"
						placeholder={t('0')}
						defaultValue={''}
					/>
				</Form.Item>
			</Col>

			<Col {...colSpan}>
				<Form.Item
					label={edit !== undefined ? t('onboarding.provinceNew') : t('onboarding.provinceNew')}
					name="province"
					rules={[
						{
							required: true
						}
					]}>
					<ProvinceSelector
						style={{ width: '100%' }}
						onChange={(e) => onChangeProvince(e)}
						placeholder={t('form.select')} />
				</Form.Item>
			</Col>

			{edit === undefined && (
				<Col span={24}>
					<Form.Item
						name="whenSignedMortgage"
						label={t('onboarding.singDateQuestion')}
						style={{
							width: '100%',
							display: !isMobileOnly ? 'grid' : undefined
						}}
						rules={[
							{
								required: true
							}
						]}
					>
						<Radio.Group
							onChange={(e) => setValueRadio(e.target.value)}
							style={{
								width: '100%',
								display: 'grid'
							}}>
							<Space direction="vertical">
								<Radio value="moreThanOneYear">
									{t('onboarding.overYearAgo1')}&nbsp;
									<strong>{t('onboarding.overYearAgo2')}</strong> {t('onboarding.overYearAgo3')}
								</Radio>

								{valueRadio === 'moreThanOneYear' && (
									<Form.Item
										name="dateSign"
										rules={[
											{
												required: true
											}
										]}>
										<DatePicker
											id="dateSign"
											format={'MM/YYYY'}
											picker="month"
											style={{
												width: '100%',
												border: '1px solid #C0DAEE',
												borderRadius: 4,
												height: 40
											}}
										/>
									</Form.Item>
								)}

								<Radio
									value="lessThanOneYear"
									style={{ marginTop: valueRadio === 'moreThanOneYear' ? -16 : 0 }}>
									{t('onboarding.overYearAgo1')}&nbsp;
									<strong>{t('onboarding.lessThanYearAgo4')}&nbsp;</strong>
									{t('onboarding.overYearAgo3')}
								</Radio>
							</Space>
						</Radio.Group>
					</Form.Item>
				</Col>
			)}
			{edit !== undefined && (
				<Col {...colSpan}>
					<Form.Item name="whenSignedMortgage" label={t('suborgation.initialSignatureDate')}>
						<Select
							onChange={(value) => setValueEditMortgage(value)}
							placeholder={t('form.activity')}
							suffixIcon={<img src={DownOutlinedMobile} alt="DownOutlinedMobile" />}>
							<Option value="moreThanOneYear">
								{t('onboarding.overYearAgo1')}&nbsp;
								{t('onboarding.overYearAgo2')}&nbsp;
								{t('onboarding.overYearAgo3')}{' '}
							</Option>
							<Option value="lessThanOneYear">
								{t('onboarding.overYearAgo1')}&nbsp;
								{t('onboarding.lessThanYearAgo4')}&nbsp;
								{t('onboarding.overYearAgo3')}
							</Option>
						</Select>
					</Form.Item>
				</Col>
			)}
			{edit !== undefined && valueEditMortgage === 'moreThanOneYear' && (
				<Col {...colSpan}>
					<Form.Item
						name="dateSign"
						rules={[
							{
								required: true
							}
						]}>
						<DatePicker
							id="dateSign"
							format={'MM/YYYY'}
							picker="month"
							style={{
								width: '100%',
								border: '1px solid #C0DAEE',
								borderRadius: 4,
								height: 40,
								marginTop: 24
							}}
						/>
					</Form.Item>
				</Col>
			)}

			<Modal
				className="ModalCommon"
				open={modalAndalucia}
				title={t('andaluciaModal.title')}
				width={480}
				closable={true}
				cancelButtonProps={{
					className: 'button-secundary-gibobs',
					style: { width: '46%', height: 40, fontSize: 14 }
				}}
				okButtonProps={{
					className: 'button-primari-gibobs',
					style: { width: '46%', height: 40, fontSize: 14 }
				}}
				onCancel={() => backTop()}
				onOk={() => closeOperation()}
				centered>
				<div style={{ marginBottom: 20, marginTop: -30 }}>
					<Text style={{ color: '#748EA0', fontSize: 14, fontWeight: 400, }}>
						{t('andaluciaModal.text')}
					</Text>
				</div>
			</Modal>
		</>
	);
};

export default CurrentMortgageForm2;
